import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { isHipaaLink } from '../../../../config/productProfile';
import WelcomeBakground from '../../../../assets/images/welcome-background.png';
import styles from './WelcomeLayout.module.scss';

export const WelcomeLayout = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('providerRoom');

  const handleGetStartedClick = () => {
    navigate('/edit');
  };

  return (
    <Box className={styles.welcomeContainer}>
      <Box className={styles.innerBox}>
        <img className={styles.image} src={WelcomeBakground} alt='' />

        <Typography variant='h4' component='h4' className={styles.welcomeText}>
          {t('createWaitingRoomStartPrefix')}{' '}
          {isHipaaLink ? (
            <>
              HIPAA<span className={styles.link}>LINK</span>
            </>
          ) : (
            <>
              <strong>VIA3</strong>
            </>
          )}
        </Typography>

        <Button variant='contained' onClick={handleGetStartedClick}>
          {t('getStarted')}
        </Button>
      </Box>
    </Box>
  );
};
